import { APPLICATIONS_URL, brokerRedirect } from '@organization/app-constants'
import { useSessionContext } from '@shared/hooks'
import { setLocalStorageToken } from '@shared/utils'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

type Token = { access: string; refresh: string; device_token?: string }

export const useSuccessLogin = () => {
  const navigate = useNavigate()
  const { updateUserData } = useSessionContext()

  const auth = async (token: Token) => {
    setLocalStorageToken(token)

    const data = await updateUserData()

    const pathname = data?.broker
      ? brokerRedirect(data.broker.token)
      : APPLICATIONS_URL

    navigate({ pathname }, { relative: 'path' })
  }

  return useMemo(() => ({ auth }), [])
}
